<script setup>
import { Loc } from 'main.core';
import useCalculatorStore from '../../../store/calculator.js';

const calculator = useCalculatorStore();
</script>

<template>
  <p class="cloud-calculator__summary-row cloud-calculator__summary-row_total">
    <span class="cloud-calculator__summary-label">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_CALCULATION_TOTAL') }}
    </span>
    <span class="cloud-calculator__summary-value">
      {{ calculator.total }}₸
    </span>
  </p>
  <p class="cloud-calculator__summary-hint">
    {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_SUMMARY_VAT') }}
  </p>
</template>
